import { Outlet, Navigate } from 'react-router';
import { useLogin } from '../../hooks/useLogin';
import { Loader } from '@f2m3/shared-frontend-ui';

const ProtectedRoute = () => {
  const { isLoggedIn, isPending, isFetching } = useLogin();

  if (isLoggedIn) {
    return <Outlet />;
  }

  // A refetch in flight means the cached "not logged in" may be stale (a token
  // just arrived — see useLogin.isFetching); wait for it rather than redirect.
  if (isPending || isFetching) {
    return <Loader />;
  }

  return <Navigate to="/login" />;
}

export default ProtectedRoute;
